import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft, Heart, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';

const Guidelines = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        {/* Back button */}
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6"
          data-testid="guidelines-back-btn"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>

        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-8 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <Heart className="h-6 w-6 text-green-600" />
            </div>
            <h1 className="text-3xl font-bold text-gray-900">Community Guidelines</h1>
          </div>
          <div className="w-16 h-1 bg-gradient-to-r from-green-600 to-blue-600 rounded-full mb-6"></div>
          
          <p className="text-lg text-gray-700 leading-relaxed">
            POLIVOX is a space for respectful and meaningful discussion.
          </p>
        </div>

        {/* Content Sections */}
        <div className="space-y-6">
          {/* Do's */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <CheckCircle className="h-5 w-5 text-green-600" />
              <h2 className="text-xl font-semibold text-gray-900">What We Encourage</h2>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              Users must:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                </div>
                <span>Be respectful to others</span>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                </div>
                <span>Avoid personal attacks</span>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <CheckCircle className="h-4 w-4 text-green-600" />
                </div>
                <span>Share accurate and responsible information</span>
              </li>
            </ul>
          </div>

          {/* Don'ts */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <XCircle className="h-5 w-5 text-red-600" />
              <h2 className="text-xl font-semibold text-gray-900">What Is Not Allowed</h2>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              The following are not allowed:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
                <span>Hate speech</span>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
                <span>Violence or threats</span>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
                <span>Harassment</span>
              </li>
              <li className="flex items-start gap-3 text-gray-600">
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <XCircle className="h-4 w-4 text-red-600" />
                </div>
                <span>Spam or misleading content</span>
              </li>
            </ul>
          </div>

          {/* Enforcement */}
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center gap-3 mb-4">
              <AlertTriangle className="h-5 w-5 text-amber-600" />
              <h2 className="text-xl font-semibold text-gray-900">Enforcement</h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              Violations may result in content removal or account suspension. We take these 
              guidelines seriously to maintain a healthy community.
            </p>
          </div>

          {/* Closing Note */}
          <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-6 border border-green-100">
            <p className="text-gray-700 text-center font-medium">
              Let's keep POLIVOX a healthy and constructive platform.
            </p>
          </div>
        </div>

        {/* Last updated */}
        <div className="text-center text-gray-400 text-sm mt-8">
          <p>Last updated: March 2026</p>
        </div>
      </div>
    </div>
  );
};

export default Guidelines;
